(ns common.feedback-status
  (:require [common.util :as cu]))

(defonce options [{:key   :feedback.status/draft
                   :label "Draft"}
                  {:key   :feedback.status/submitted
                   :label "Submitted"}
                  {:key   :feedback.status/canceled
                   :label "Canceled"}])

(def get-key (partial cu/get-key options))

(def get-label (partial cu/get-label options))
